import { ReactNode, useEffect, useRef } from "react";
import styled from "styled-components";
import { FieldButton } from "components/voc";
import BtnClose from "assets/images/btn_popup_close.png";
import IconSelect from "assets/images/icon_select.png";

type BottomSheetProps = {
  title: string;
  children: ReactNode;
  show: boolean;
  formId?: string;
  fullPage?: boolean;
  onClose: () => void;
};

const BottomSheetWrapper = styled.div<{ fullPage?: boolean }>`
  [class^="c_bottomsheet"] {
    z-index: 10;
    opacity: 0;
    visibility: hidden;
    display: flex;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    align-items: flex-end;
    background-color: rgba(68, 68, 68, 0.8);
    transform: translateY(100%);
    transition: opacity 0.2s;
  }

  [class^="c_bottomsheet"].-active {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
  [class^="c_bottomsheet"].-active .inner {
    transform: translateY(0);
  }
  [class^="c_bottomsheet"].-hide {
    opacity: 0;
    transition: 0.2s;
    transition-delay: 0.1s;
  }
  [class^="c_bottomsheet"].-hide .inner {
    transform: translateY(100%);
  }
  [class^="c_bottomsheet"] .inner {
    display: flex;
    flex-direction: column;
    transform: translateY(100%);
    transition: 0.2s;
    ${(props) =>
      !props.fullPage &&
      `border-radius: 2rem 2rem 0 0;
      max-height: calc(100% - 7rem);`}
    ${(props) =>
      props.fullPage &&
      `border-radius: 0;
      height: 100%;
    `}
    width: 100%;
    background-color: #fff;
  }
  [class^="c_bottomsheet"] .box_header {
    flex-shrink: 0;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 4rem 3.2rem 0;
  }
  [class^="c_bottomsheet"] .box_header .txt_title {
    font-weight: 400;
    font-size: 1.8rem;
    line-height: 2.2rem;
  }
  [class^="c_bottomsheet"] .box_header .btn_close {
    position: absolute;
    top: 0;
    right: 0;
    width: 2.2rem;
    height: 2.2rem;
    padding: 1.8rem;
    box-sizing: content-box;
  }
  [class^="c_bottomsheet"] .box_header .btn_close i {
    display: block;
    width: 2.2rem;
    height: 2.2rem;
    ${(props) => !props.fullPage && `background: url(${BtnClose}) no-repeat center;`}
    ${(props) => props.fullPage && `background: url(${IconSelect}) no-repeat center;`}
    background-size: 2.2rem;
  }
  [class^="c_bottomsheet"] .box_contents {
    position: relative;
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 2rem 3.2rem;
  }

  .ad_bottomsheet .box_contents {
    padding-top: 0;
  }
  .ad_bottomsheet .btn_page_bottom {
    z-index: 0;
    position: relative;
    padding: 2rem 3.2rem;
  }
  .ad_bottomsheet .btn_page_bottom::before {
    z-index: -1;
    position: absolute;
    top: -2rem;
    left: 0;
    right: 0;
    height: 100%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 3.18%, rgba(255, 255, 255, 0.8) 12.6%, #ffffff 20.91%);
    content: "";
  }
  .ad_bottomsheet .btn_page_bottom .btn_default {
    width: 100%;
  }
`;

const BottomSheet = ({ title, children, show, formId, fullPage, onClose, ...props }: BottomSheetProps) => {
  const sheetRef = useRef<HTMLDivElement>(null);

  const handleSheet = {
    show: () => {
      const sheet = sheetRef.current;
      sheet?.classList.add("-active");
      document.body.style.overflow = "hidden";
    },
    hide: () => {
      const sheet = sheetRef.current;
      sheet?.classList.add("-hide");
      document.body.style.overflow = "";
      setTimeout(() => {
        sheet?.classList.remove("-active");
        sheet?.classList.remove("-hide");
      }, 300);
    },
  };

  useEffect(() => {
    if (show) {
      handleSheet.show();
    } else {
      handleSheet.hide();
    }
  }, [show]);

  return (
    <>
      <BottomSheetWrapper fullPage={fullPage}>
        <div className="c_bottomsheet ad_bottomsheet" ref={sheetRef}>
          <div className="inner">
            <div className="box_header">
              <strong className="txt_title">{title}</strong>
              <FieldButton className="btn_close" onClick={onClose}>
                <i>닫기</i>
              </FieldButton>
            </div>
            <div className="box_contents">{children}</div>
            {formId && (
              <div className="btn_page_bottom">
                <FieldButton className="btn_default -lg" form={formId} type={"submit"}>
                  등록하기
                </FieldButton>
              </div>
            )}
          </div>
        </div>
      </BottomSheetWrapper>
    </>
  );
};

export default BottomSheet;
